module.exports = __webpack_public_path__ + "img/jsonpath-help2.d7ed4e2f.png";